// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Fiji from '../_raw/flag/icon_flag_fiji.png';

export default () => <img src={Fiji} alt="Fiji" />;
